export const social_media_color = [
    {
        name: 'Facebook',
        hex: '#1877F2',
        rgb: 'RGB(24, 119, 242)',
        hsl: 'HSL(214, 89%, 52%)',
        avatar: 'https://cdn-icons-png.flaticon.com/128/747/747374.png'
    },
    {
        name: 'WhatsApp',
        hex: '#25D366',
        rgb: 'RGB(37, 211, 102)',
        hsl: 'HSL(134, 65%, 50%)',
        avatar: 'https://cdn-icons-png.flaticon.com/128/1384/1384023.png'
    },
    {
        name: 'Instagram',
        hex: '#E4405F',
        rgb: 'RGB(228, 64, 95)',
        hsl: 'HSL(345, 75%, 57%)',
        avatar: 'https://cdn-icons-png.flaticon.com/128/717/717392.png'
    },
    {
        name: 'Twitter',
        hex: '#1DA1F2',
        rgb: 'RGB(29, 161, 242)',
        hsl: 'HSL(203, 90%, 54%)',
        avatar: 'https://cdn-icons-png.flaticon.com/128/739/739257.png'
    },
    {
        name: 'Snapchat',
        hex: '#FFFC00',
        rgb: 'RGB(255, 252, 0)',
        hsl: 'HSL(58, 100%, 50%)',
        avatar: 'https://cdn-icons-png.flaticon.com/128/220/220366.png'
    },
    {
        name: 'GitHub',
        hex: '#181717',
        rgb: 'RGB(24, 23, 23)',
        hsl: 'HSL(0, 4%, 9%)',
        avatar: 'https://cdn-icons-png.flaticon.com/128/1240/1240971.png'
    },
    {
        name: 'LinkedIn',
        hex: '#0A66C2',
        rgb: 'RGB(10, 102, 194)',
        hsl: 'HSL(208, 90%, 40%)',
        avatar: 'https://cdn-icons-png.flaticon.com/128/1384/1384088.png'
    }
]